import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SvgIconModule } from '@toro/common/shared/components/svg-icon/svg-icon.module';
import { ChartsModule } from '../../charts/charts.module';
import { TradingViewModule } from '../../../partials/tradingview/tradingview.module';
import { DialogGraphicComponent } from './dialog-graphic.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
        RouterModule,
        ChartsModule,
        TradingViewModule,
    ],
    exports: [ DialogGraphicComponent ],
    declarations: [ DialogGraphicComponent ],
    entryComponents: [ DialogGraphicComponent ],
})
export class DialogGraphicModule {}
